import { render, staticRenderFns } from "./ElementForm.vue?vue&type=template&id=aeedbb34&scoped=true&"
import script from "./ElementForm.vue?vue&type=script&lang=js&"
export * from "./ElementForm.vue?vue&type=script&lang=js&"
import style0 from "./ElementForm.vue?vue&type=style&index=0&id=aeedbb34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeedbb34",
  null
  
)

export default component.exports